import data from '@/data'
import * as types from './mutation-types.js'
import axios from 'axios'
import vm from '@/main'

export default {
  namespaced: true,
  state: () => ({
    //八大类人群
    crowdData: [],
    // 热词
    wordData: [{
        name: '小区',
        value: 130,
      },
      {
        name: '雨污',
        value: 127,
      },
      {
        name: '建设',
        value: 105,
      },
      {
        name: '行业',
        value: 105,
      },
      {
        name: '化粪',
        value: 100,
      },
      {
        name: '雨水',
        value: 94,
      },
      {
        name: '餐饮',
        value: 92,
      },
      {
        name: '检测',
        value: 91,
      },
      // {
      //   name: '流动',
      //   value: 88,
      // },
      // {
      //   name: '整改',
      //   value: 84,
      // },
    ],
    cityData: [
		[{
          name: "东源镇",
          value: 'jingshan'
        },
        {
          name: "瓯南街道",
          value: 'wutian'
        },
        {
          name: "油竹街道",
          value: 'nbx'
        },
        {
          name: "温溪镇",
          value: 'chashan'
        }
      ]
    ],
    // 心福工坊数据
    xfgfData: {
      config1: {
        number: [5],
        content: '{nt}公里',
        style: {
          fill: '#00ffff',
          fontSize: 28,
        },
      },
      config2: {
        number: [18],
        content: '{nt}公里',
        style: {
          fill: '#e91315',
          fontSize: 28,
        },
      },
    },
    // 建设完成统计
    infoData: [
      ['city', '已完成', '未完成'],
      ['东源村', 80, 20],
      ['五星村', 10, 90],
      ['武陵村', 0, 100],
      ['项村村', 10, 90],
      ['红光村', 0, 100],
    ],
    warnData: [],
    sexData: [],
    ageData: [],
    warnList: {},
    // 事件数据
    taskList: [],
  }),
  getters: {
    crowdData: (state) => {
      const crowdData = state.crowdData.map((item) => {
        return {
          title: item.ctype,
          total: {
            number: [item.t],
            content: item.t === 0 ? '0' : '{nt}',
            style: {
              fontSize: 14,
              fill: '#ffffff',
              textBaseline: 'bottom',
            },
          },
          add: {
            number: [item.c],
            content: item.c === 0 ? '0' : '{nt}',
            style: {
              fontSize: 14,
              fill: '#e91315',
            },
          },
        }
      })
      return crowdData
    },
    wordData: (state) => state.wordData,
    xfgfData: (state) => state.xfgfData,
    eventData: (state) => state.eventData,
    cityData: (state) => state.cityData,
    sexData: (state) => state.sexData,
    ageData: (state) => state.ageData,
    infoData: (state) => state.infoData,
    warnList: (state) => state.warnList,
    taskList: (state) => {
      // console.log(data.ouhai.taskData)
      return {
        header: [
          '<span style="color:#37f3f3">事件名称</span>',
          '<span style="color:#37f3f3">处理状态</span>',
        ],
        // headerHeight: 24,
        headerBGC: 'transparent',
        data: state.taskList,
        columnWidth: ['350'],
        rowNum: 5,
      }
    },
  },
  mutations: {
    [types.GET_CROWD_DATA](state, payload) {
      axios.post('/ctypeCnt', {key: payload}).then((res) => {
        state.crowdData = res.data.data
      })
    },
    [types.GET_SEX_DATA](state, payload) {
      state.sexData = data[payload].sexData
    },
    [types.GET_AGE_DATA](state, payload) {
      state.ageData = data[payload].ageData
    },
    [types.GET_WARN_LIST](state, payload) {
      payload.forEach((item) => {
        let {
          Level
        } = item
        if (!state.warnList[Level]) {
          vm.$set(state.warnList, Level, [])
        }
        state.warnList[Level].push(item)
      })
    },
    [types.GET_TASK_LIST](state, payload) {
      let map = new Map([
        ['1', '未发布'],
        ['2', '已发布'],
        ['3', '未完成'],
        ['4', '已完成'],
      ])
      let data = payload.map((item) => {
        return [item.STREET, map.get(item.STATUS)]
      })
      state.taskList = data
    },
  },
  actions: {
    getWarnList({
      commit
    }) {
     
    },
    getTaskList({
      commit
    }) {
      axios.post('/ctypeCnt', {
          STREETID: '永嘉县'
        })
        .then((res) => {
          //let data = res.data.ResultData.slice(0, 20)
          // console.log(data)
          //commit(types.GET_TASK_LIST, data)
          // console.log(res)
        })
    },
  },
}